import { render, staticRenderFns } from "./NavbarItem.vue?vue&type=template&id=655b542e&scoped=true&"
import script from "./NavbarItem.vue?vue&type=script&lang=js&"
export * from "./NavbarItem.vue?vue&type=script&lang=js&"
import style0 from "./NavbarItem.vue?vue&type=style&index=0&id=655b542e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655b542e",
  null
  
)

export default component.exports